import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, CanActivate } from '@angular/router';
import swal from 'sweetalert2';
@Injectable({
  providedIn: 'root'
})
export class PermisosGuard implements CanActivate  {
  canActivate(route: ActivatedRouteSnapshot){
    const PERMISOS:Array<any> = JSON.parse(localStorage.permisos);
    //console.log(route.data.id_permiso);
    let allowed:boolean = false;
    for(let permiso of PERMISOS){
      if (permiso.permiso == route.data.id_permiso){
        allowed = true;
      }
    }
    if(!allowed){
      swal.fire({
        showCancelButton:false,
        showConfirmButton:true,
        title:'No tienes permiso para ingresar a este lugar',
        text:'Comunicate con el administrador si crees que esto es un error'
      })
    }
    return allowed;
  }
  
}
